export default __webpack_public_path__ + "static/media/toyota.4ff624b6.svg";